export default __webpack_public_path__ + "static/media/doneIcon.dddf9f67.svg";